export default "__VITE_ASSET__922c637f__"